const { $sanctumAuth } = useNuxtApp();

export const useLogOut = async (): Promise<void> => {
  await $sanctumAuth.logout(async (): Promise<void> => {
    await navigateTo('/login');
  });
};
